import React, { useEffect, useState } from 'react';
import API from '../api';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './styles.css';

function WhatsAppNotifications() {
  const { t, i18n } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchOrders() {
      setLoading(true);
      try {
        const res = await API.get('orders/whatsapp-notifications/');
        setOrders(res.data || []);
      } catch (e) {
        setOrders([]);
      }
      setLoading(false);
    }
    fetchOrders();
  }, []);

  const getWhatsAppLink = (number, message) => {
    if (!number) return null;
    // Remove any non-digit chars, add country code if needed
    let phone = number.replace(/\D/g, '');
    if (phone.length === 10 && phone.startsWith('05')) phone = '966' + phone.slice(1); // Saudi example
    if (!phone.startsWith('966') && phone.length < 11) phone = '966' + phone; // fallback
    return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  };

  const getMessage = (office, order) => {
    return t('order_delivered_message', { office, order: order.order_number });
  };

  return (
    <div className={`whatsapp-notifications page-container${i18n.language === 'ar' ? ' rtl' : ''}`}> 
      <div className="login-buttons">
        <button onClick={() => navigate('/')}>🏠 {t('Home')}</button>
        <button onClick={() => navigate(-1)}>🔙 {t('Back')}</button>
      </div>
      <h1>{t('WhatsApp Notifications')}</h1>
      <p>{t('orders_with_whatsapp_notification')}</p>
      {loading ? <div>{t('Loading...')}</div> : (
        <table className="orders-table">
          <thead>
            <tr>
              <th>{t('Order Number')}</th>
              <th>{t('Customer')}</th>
              <th>{t('Delivery Customer')}</th>
              <th>{t('Send to Customer')}</th>
              <th>{t('Send to Delivery Customer')}</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(order => (
              <tr key={order.id}>
                <td>{order.order_number}</td>
                <td>{order.customer_name}</td>
                <td>{order.delivery_customer_name}</td>
                <td>
                  {order.customer_whatsapp ? (
                    <a href={getWhatsAppLink(order.customer_whatsapp, getMessage(order.office_name, order))} target="_blank" rel="noopener noreferrer" className="wa-btn">{t('Send WhatsApp')}</a>
                  ) : order.customer_phone ? (
                    <span>{t('No WhatsApp')}: {order.customer_phone}</span>
                  ) : (
                    <span>{t('No Contact')}</span>
                  )}
                </td>
                <td>
                  {order.delivery_customer_whatsapp ? (
                    <a href={getWhatsAppLink(order.delivery_customer_whatsapp, getMessage(order.office_name, order))} target="_blank" rel="noopener noreferrer" className="wa-btn">{t('Send WhatsApp')}</a>
                  ) : order.delivery_customer_phone ? (
                    <span>{t('No WhatsApp')}: {order.delivery_customer_phone}</span>
                  ) : (
                    <span>{t('No Contact')}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default WhatsAppNotifications;
